import { motion } from 'motion/react';

type AnimateRotateProps = {
  degrees: number;
  duration?: number;
  isTriggered: boolean;
  children: React.ReactNode;
};

export const AnimateRotate = ({ children, duration, isTriggered, degrees }: AnimateRotateProps) => (
  <motion.div
    initial={{ rotate: 0 }}
    animate={{
      rotate: isTriggered ? degrees : 0,
    }}
    transition={{
      duration: duration ? duration : 0.3,
    }}
    style={{ display: 'inline-flex' }}
  >
    {children}
  </motion.div>
);
